export const SCAN_TO_VIEW = '^#^**^';
